import React from 'react';

export const CancelledCell: React.FunctionComponent = () => {
  return (
    <div className="dateCell__message-cancelled">
      <div className="dateCell__message-cancelled__label">Cancelled</div>
    </div>
  );
};
